import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UiVisibilitySettingDTO } from "../../../types/ui";

/** 🧱 Estado inicial */
export interface UiVisibilityState {
  settings: UiVisibilitySettingDTO[];
  loading: boolean;
  error: string | null;
}

/** 🌱 Estado base */
const initialState: UiVisibilityState = {
  settings: [],
  loading: false,
  error: null,
};

export const uiVisibilitySlice = createSlice({
  name: "uiVisibility",
  initialState,
  reducers: {
    // =====================================================
    // 🔹 CARGA DE CONFIGURACIONES
    // =====================================================

    /** 🔄 Inicia la carga de configuraciones */
    startLoading: (state) => {
      state.loading = true;
      state.error = null;
    },

    /** ✅ Carga exitosa de configuraciones */
    setUiSettings: (state, action: PayloadAction<UiVisibilitySettingDTO[]>) => {
      state.settings = action.payload;
      state.loading = false;
      state.error = null;
    },

    /** ❌ Error en la carga o actualización */
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    // =====================================================
    // 🔹 ACTUALIZACIÓN DE VISIBILIDAD
    // =====================================================

    /**
     * ✅ Actualiza el valor `visible` según respuesta real del backend
     */
    updateVisibilityState: (
      state,
      action: PayloadAction<{ code: string; visible: boolean }>
    ) => {
      const index = state.settings.findIndex(
        (item) => item.code === action.payload.code
      );
      if (index !== -1) {
        state.settings[index].visible = action.payload.visible;
      }
      state.loading = false;
      state.error = null;
    },

    /** 🧹 Reinicia completamente el estado */
    resetUiVisibilityState: () => initialState,
  },
});

// =====================================================
// 📤 EXPORTAR ACTIONS
// =====================================================
export const {
  startLoading,
  setUiSettings,
  setError,
  updateVisibilityState,
  resetUiVisibilityState,
} = uiVisibilitySlice.actions;

// =====================================================
// 📤 EXPORTAR REDUCER
// =====================================================
export default uiVisibilitySlice.reducer;
